import styled from 'styled-components';
import { __ } from '../../i18n/l10n';
import { COLORS } from '../../styles/colors';
import { splitNumber } from '../../utils/splitNumber';

export interface WxBankRollProps {
  /**
   * Balance of the player in miles
   */
  balance: number;
}

const WxBankroll = ({ balance }: WxBankRollProps) => {
  return (
    <Container>
      <Paragraph>{`${splitNumber(balance)} ${__('MILES')}`}</Paragraph>
    </Container>
  );
};

const Container = styled.div`
  width: fit-content;
`;

const Paragraph = styled.p`
  font-weight: 900;
  background-color: ${COLORS.red};
  color: ${COLORS.white};
  padding: 0.5rem 0.875rem;

  @media (min-width: 1024px) {
    padding: 0.5rem 1.875rem;
  }
`;

export default WxBankroll;
